import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";


const Ulist = styled.ul`
    list-style: none;
    display: flex;
    align-items: center;
    padding: 0px;
`
const LinkStyle = styled(Link)`
    text-decoration: none;
    color: white;
`
const List = styled.li`
    list-style: none;
    padding: 0px 10px;
    border-left: ${props=> props.bl? props.bl : ''};
    @media (max-width: 850px){
        display: none;
    }
`
const ListItems = styled.a`
    text-decoration: none;
    color: white;
    font-family: poppins-regular;
    font-size: 15px;
    cursor: pointer;
`
const IconStyle = styled.a`
    background-color: white;
    padding: ${props => props.p? props.p : '10px 10px 5px'};
    margin: 10px 10px 10px 0px;
    border-radius: 10px;
`
const AllImage = styled.img`
    width: 100%;
    height: auto;
    max-width: ${props => props.maxw? props.maxw : ''};
    padding: ${props => props.p? props.p : ''};
    
`
const Paragraph = styled(Typography)`
    font-family: poppins-regular;
    font-size: ${props => props.fs? props.fs : ''};
    text-align: ${props => props.ta? props.ta : 'center'};
    padding:  ${props => props.p? props.p : ''};
    margin: ${props => props.m? props.m : ''};
    color: #FFFFFF;
    max-width: ${props => props.mw? props.mw : ''};
    line-height: 20px;
`
// ...............................muidrawer.............................

const Menustyling = styled.div`
min-height: 100vh;
display: flex;
flex-direction: column;
padding: 20px 0px;
`;
const Liststyling = styled.li`
padding: 10px 12px;
display: flex;
list-style: none;
display: block;
text-align: left;
padding: ${props => props.pd? props.pd : '10px 10px'};
`;
const Listdrawer = styled.a`
color: white;
text-decoration: none;
font-size: 18px; 
margin: 1rem 0;
padding: 8px 12px;
font-family: poppins-semibold;
`;
const NavBtn = styled.div`
padding: 0px;
display: none;
cursor: pointer;
font-size: 1.8rem; 
color: white;
@media (max-width: 850px){
    display: block;
}
`;
export { Ulist, List, ListItems, IconStyle,LinkStyle, Paragraph, AllImage, Menustyling, Liststyling, Listdrawer, NavBtn }